<template>
  <HeaderCustom title="Gestão do Conhecimento">
    <v-row>
      <v-col>
        <CardParametrosConsulta />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <ResultadoConsulta v-show="totalElementos" />
      </v-col>
    </v-row>
  </HeaderCustom>
</template>

<script lang="ts" setup>
import CardParametrosConsulta from './components/consulta/CardParametrosConsulta.vue';
import ResultadoConsulta from './components/consulta/ResultadoConsulta.vue';
import { ConsultaParecerStore } from '@/views/parecer/store/ConsultaParecerStore';
import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router/composables';

import HeaderCustom from '../components/HeaderCustom.vue';
const route = useRoute();
const store = ConsultaParecerStore();
store.isPrivado = (route.meta?.isPrivado as boolean) ?? false;
const { totalElementos } = storeToRefs(store);
</script>
